/* Cover My Plate · matching-piece pictures for the cart and emails (Nov 2026, Brian: upsells must look exactly
   like what the customer gets).
   When a design is added to the cart from a builder that shows "Make it a set" (plate cover builders), this draws
   the builder's own picture of each matching piece, the same picture the customer saw in "Make it a set" (their
   design laid out on the frame, vanity plate and mini plate, including any "Adjust layout" changes), uploads them
   in the background, and saves the links on the design's cart line as hidden properties:
     "_Match Frame", "_Match Vanity", "_Match Mini" (+ "_Match Frame Style": black / match, so a frame added from the
     cart is the same frame its picture shows)
   The cart's "Match the rest of your car" tiles, pieces added from those tiles, and emails show these pictures.
   Keychains are left out for now: graphics is supplying the keychain picture to use.
   Nothing else on the line changes, and Add to cart doesn't wait for these uploads (assets/cmp-uploads.js).
   Loaded from sections/cmp-seo.liquid on the builder pages. */
(function () {
  'use strict';
  if (window.__cmpMatchPv) return;
  window.__cmpMatchPv = true;

  // the builder's piece shapes (same as assets/cx-util.js): width / height of each piece
  var PIECES = [
    { key: 'frame', ar: 1.93, prop: '_Match Frame' },
    { key: 'vanity', ar: 2, prop: '_Match Vanity' },
    { key: 'mini', ar: 4, prop: '_Match Mini' }
  ];

  function builder() {
    var inst = null;
    document.querySelectorAll('[data-cxc]').forEach(function (el) {
      if (!inst && el._cxc && typeof el._cxc.morePreview === 'function' && el.querySelector('[data-cxm-item]')) inst = el._cxc;
    });
    return inst;
  }

  /* Returns the picture links for every piece the builder offers on this page. Never throws. */
  function pictures(inst) {
    var base = 'match-' + Date.now().toString(36);
    return Promise.all(PIECES.map(function (p) {
      var card = inst.root && inst.root.querySelector('[data-cxm-item="' + p.key + '"]');
      if (!card || card.hidden) return null;
      var data;
      try { data = inst.morePreview({ key: p.key, ar: p.ar }); } catch (e) { return null; }
      if (!data) return null;
      return Promise.resolve(inst.upload(data, base + '-' + p.key + '-preview.jpg')).then(function (url) {
        return url ? { prop: p.prop, url: url } : null;
      }, function () { return null; });
    })).then(function (list) { return list.filter(Boolean); }, function () { return []; });
  }

  (function hook(n) {
    var M = window.CMP;
    if (!M || !M.addItems) { if (n < 100) setTimeout(function () { hook(n + 1); }, 200); return; }
    if (M.addItems._cmpMatch) return;
    var add = M.addItems;
    var wrapped = function (items) {
      var self = this, args = arguments, it = items && items[0], inst = builder();
      // only a design line from a builder with "Make it a set" (frames added on their own page are left alone)
      if (!inst || inst.kind === 'frame' || !it || !it.properties || !it.properties['_Design HQ'] || it.properties['_Match Vanity'] || it.properties['_Match Frame']) {
        return add.apply(self, args);
      }
      return pictures(inst).then(function (list) {
        list.forEach(function (x) { it.properties[x.prop] = x.url; });
        // which frame the picture shows: black with the logo and text, or printed with the background ("match")
        if (it.properties['_Match Frame']) it.properties['_Match Frame Style'] = (inst.frameStyle && inst.frameStyle()) || 'black';
        return add.apply(self, args);
      }, function () { return add.apply(self, args); });
    };
    Object.keys(add).forEach(function (k) { wrapped[k] = add[k]; });
    wrapped._cmpMatch = 1;
    M.addItems = wrapped;
  })(0);
})();
